import {
  postImage,
  deleteImage
} from '../api'

const state = {
  image: null
}

const mutations = {
  NEW_IMAGE(state, image) {
    state.image = image
  }
}

const actions = {
  uploadImage({ commit, state }, file) {
    postImage(file)
      .then(newImage => {
        commit('NEW_IMAGE', newImage.data)
      })
  },
  
}

export default {
  strict: true,
  state,
  actions,
  mutations
}
